import { __extends } from "tslib";
import { ImageBase } from '@awayjs/stage';
import { DefaultRenderer, DepthRenderer, DistanceRenderer, ImageTexture2D } from '@awayjs/renderer';
import { MaterialBase } from './MaterialBase';
/**
 * BasicMaterial forms an abstract base class for the default shaded materials provided by Stage,
 * using material methods to define their appearance.
 */
var BasicMaterial = /** @class */ (function (_super) {
    __extends(BasicMaterial, _super);
    function BasicMaterial(imageColor, alpha) {
        if (imageColor === void 0) { imageColor = null; }
        if (alpha === void 0) { alpha = 1; }
        var _this = _super.call(this, imageColor, alpha) || this;
        _this._preserveAlpha = false;
        //set a texture if an image is present
        if (imageColor instanceof ImageBase)
            _this.texture = new ImageTexture2D();
        return _this;
    }
    Object.defineProperty(BasicMaterial.prototype, "assetType", {
        /**
         *
         */
        get: function () {
            return BasicMaterial.assetType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicMaterial.prototype, "preserveAlpha", {
        /**
         * Indicates whether alpha should be preserved - defaults to false
         */
        get: function () {
            return this._preserveAlpha;
        },
        set: function (value) {
            if (this._preserveAlpha == value)
                return;
            this._preserveAlpha = value;
            this.invalidate();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasicMaterial.prototype, "texture", {
        /**
         * The texture object to use for the albedo colour.
         */
        get: function () {
            return this._texture;
        },
        set: function (value) {
            if (this._texture == value)
                return;
            if (this._texture)
                this.removeTexture(this._texture);
            this._texture = value;
            if (this._texture)
                this.addTexture(this._texture);
        },
        enumerable: false,
        configurable: true
    });
    BasicMaterial.assetType = '[materials BasicMaterial]';
    return BasicMaterial;
}(MaterialBase));
export { BasicMaterial };
import { MaterialUtils } from '@awayjs/renderer';
import { BlendMode } from '@awayjs/stage';
import { _Render_MaterialBase } from '@awayjs/renderer';
import { BasicMaterialPass } from './passes/BasicMaterialPass';
import { _Render_DepthMaterial, _Render_DistanceMaterial } from './MaterialBase';
import { CacheRenderer } from '@awayjs/renderer';
/**
 * RenderMaterialObject forms an abstract base class for the default shaded materials provided by Stage,
 * using material methods to define their appearance.
 */
var _Render_BasicMaterial = /** @class */ (function (_super) {
    __extends(_Render_BasicMaterial, _super);
    function _Render_BasicMaterial() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(_Render_BasicMaterial.prototype, "material", {
        get: function () {
            return this._useWeak ? this._asset.deref() : this._asset;
        },
        enumerable: false,
        configurable: true
    });
    _Render_BasicMaterial.prototype.init = function (material, renderElements) {
        _super.prototype.init.call(this, material, renderElements);
        this._pAddPass(this._pass = new BasicMaterialPass(this, renderElements));
    };
    _Render_BasicMaterial.prototype.onClear = function () {
        _super.prototype.onClear.call(this);
        this._pRemovePass(this._pass);
        this._pass = null;
    };
    /**
     * @inheritDoc
     */
    _Render_BasicMaterial.prototype._pUpdateRender = function () {
        _super.prototype._pUpdateRender.call(this);
        var material = this.material;
        this.requiresBlending = (material.blendMode != BlendMode.NORMAL || material.alphaBlending || (material.colorTransform && material.colorTransform.alphaMultiplier < 1));
        this._pass.preserveAlpha = material.preserveAlpha; //this._pRequiresBlending;
        this._pass.shader.setBlendMode((material.blendMode == BlendMode.NORMAL && this.requiresBlending) ? BlendMode.LAYER : material.blendMode);
        //this._pass.forceSeparateMVP = false;
    };
    return _Render_BasicMaterial;
}(_Render_MaterialBase));
export { _Render_BasicMaterial };
CacheRenderer.registerMaterial(_Render_BasicMaterial, BasicMaterial);
DefaultRenderer.registerMaterial(_Render_BasicMaterial, BasicMaterial);
DepthRenderer.registerMaterial(_Render_DepthMaterial, BasicMaterial);
DistanceRenderer.registerMaterial(_Render_DistanceMaterial, BasicMaterial);
MaterialUtils.setDefaultMaterialClass(BasicMaterial);
